import { useCallback, useMemo } from 'react'
import { useSelector } from 'react-redux'

import { facebookRightUploadAdCampaignSelector } from '../../../../../../modules/selectors/rights'
import { campaignSelector } from '../../../../../../modules/selectors/campaigns'

// there can be two cases of ad create form: 1) simple usage on line item summary page
// 2) usage inside multi-form on digital right summary page
// in the second case, we store newly created campaign inside separate redux store
export default function useCampaignDetails() {
  const rightUploadAdCampaignData = useSelector(facebookRightUploadAdCampaignSelector)
  const { id: campaignId } = useSelector(campaignSelector)

  const { id: rightUploadAdCampaignId } = rightUploadAdCampaignData

  // if has data from right upload ad data selector, use its campaign data
  const isRightUploadAd = !!rightUploadAdCampaignId

  const getRegularCampaignData = useCallback(() => {
    return {
      campaignId
    }
  }, [campaignId])

  const getRightUploadAdCampaignData = useCallback(() => {
    return {
      campaignId: rightUploadAdCampaignId
    }
  }, [rightUploadAdCampaignId])

  return useMemo(
    () => (isRightUploadAd ? getRightUploadAdCampaignData() : getRegularCampaignData()),
    [isRightUploadAd, getRightUploadAdCampaignData, getRegularCampaignData]
  )
}
